import {
  apiRequest,
  detailSpecialAllowance,
  createSpecialAllowance,
  listComponent,
    listPenilaianBefore,
  listCriteria,
} from "../../../../../services/adapters/kepegawaian/penilaianTunjanganKhususService";

class DetailRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      detailSpecialAllowance,
      {
        params: query,
      },
      true
    );
  };

  fetchComponent = async (query) => {
    return await apiRequest(
      "get",
      listComponent,
      {
        params: query,
      },
      true
    );
  };

  fetchComponentHistory = async (query) => {
    return await apiRequest(
      "get",
      listPenilaianBefore,
      {
        params: query,
      },
      true
    );
  };

  fetchCriteria = async (query) => {
    return await apiRequest(
      "get",
      listCriteria,
      {
        params: query,
      },
      true
    );
  };

  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      createSpecialAllowance,
      {
        body: query,
      },
      true
    );
  };
}

export default DetailRepository;
